
<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol style="font-size: 25px;" col="6">
               الدورات
            </CCol>
            <CCol col="6" style="text-align: left;">
                <CButton  to="/courses/create"  square color="primary">
                    <CIcon class="c-icon" name="cil-chevron-top" /> &emsp; إضافة دورة جديدة
                </CButton>
            </CCol>
        </CRow>
        </CCardHeader>
        <CCardBody>
          <!-- Using the VdtnetTable component -->
          <vdtnet-table
             ref="table"
            :fields="fields"
            :opts="options"
            @edit="doAlertEdit"
            @show="doAlertShow"
            @delete="doAlertDelete"
            @hide="doAlertHide"
            @reloaded="doAfterReload"
            @table-creating="doCreating"
            @table-created="doCreated"
          >
          </vdtnet-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import swal from 'sweetalert'
import VdtnetTable from '../VdtnetTable.vue'
export default {
  name: 'Courses',
  components: { VdtnetTable },
  data () {
    return {
      sortDesc: true,
      options: {
        ajax: {
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              'Authorization',
              'Bearer ' + localStorage.token
            )
          },
          url: this.$hostUrl + 'courses',
          dataSrc: (json) => {
            return json.data
          }
        },
        buttons: [
          {
            extend: 'print',
            text: '',
            titleAttr: 'طباعة',
            className: 'fa fa-print btn-primary',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          },
          {
            extend: 'copy',
            text: '',
            className: 'fa fa-copy btn-warning',
            titleAttr: 'نسخ',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          },
          {
            extend: 'excel',
            text: '',
            titleAttr: 'إكسل',
            className: 'fa fa-table btn-success',
            exportOptions: {
              columns: 'th:not(:last-child)'
            }
          }
        ],
        dom:
          "<'row'<'col-sm-6 col-md-6'f><'col-sm-6 col-md-6 added'l>>" +
          "<'row'<'col-sm-12'Btr>>" +
          "<'row'<'col-sm-12 col-md-8'p><'col-sm-12 col-md-4'i>>",
        paging: true,
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/Arabic.json'
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: false,
        fixedHeader: true,
        saveState: true,
        order: [1, 'desc'],
        select: {
          style: 'multi'
        }
      },
      fields: {
        name: {
          label: 'اسم الدورة',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        created_at: {
          label: 'تاريخ الإنشاء',
          sortable: true,
          searchable: true
        },
        hide: {
          label: 'إخفاء الدورة',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        actions: {
          isLocal: true,
          label: 'العمليات',
          defaultContent: '<button href="javascript:void(0);" data-action="show" class="btn btn-info btn-sm" title="عرض التصنيف"><i class="mdi mdi-square-show-outline"></i> عرض</button>' +
            '&ensp;<a href="javascript:void(0);" data-action="edit" class="btn btn-dark btn-sm"><i class="mdi mdi-square-edit-outline"></i> تعديل</a>' +
            '&ensp;<span data-action="delete" class="btn btn-danger btn-sm"><i class="mdi mdi-delete" @click="swal"></i> حذف</span>'
        }
      },
      quickSearch: '',
      details: {}
    }
  },
  methods: {
    doLoadTable (cb) {
      this.$http.getJSON(
        this.$hostUrl + 'courses',
        function (data) {
          cb(data.data)
        }
      )
    },
    doAlertShow (data) {
      this.$router.push({ path: `/courses/${data.id}/show`, params: { id: data.id } })
    },
    doAlertEdit (data) {
      this.$router.push({
        path: `/courses/${data.id}/edit`,
        params: { id: data.id }
      })
    },
    doAlertDelete (data, row, tr, target) {
      console.log(`deleting item ID: ${data.id}`)

      swal({
        title: 'هل انت متأكد ؟',
        text: 'بمجرد الحذف ، لن تتمكن من استرداد هذا العنصر !',
        icon: 'warning',
        buttons: ['لا', 'نعم'],
        dangerMode: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((willDelete) => {
        if (willDelete) {
          this.$http
            .delete(
              `${this.$hostUrl}courses/${data.id}`,
              { _method: 'delete' }
            )
            .then((response) => {
              console.log(response, 'fir 1')
              if (response.data.error) {
                swal({ title: response.data.message, icon: 'error', buttons: 'تم' })
              } else {
                swal({ title: response.data.message, buttons: 'تم' })
                tr.remove()
                const table = this.$refs.table
                setTimeout(() => {
                  table.reload()
                }, 1500)
              }
            }).catch(response => {
              console.log(response)
              swal({ title: response.message, icon: 'error', buttons: 'تم' })
            })
        } else {
          swal({ title: ' تم الغاء العملية !', buttons: 'تم' })
        }
      })
    },
    // hide course
    doAlertHide (data, row, tr, target) {
      console.log(`deleting item ID: ${data.id}`)
      // for change swal tex
      let customText
      if (data.hide_id === 1) {
        customText = 'سيتم إخفاء الدورة من المنصة!'
      } else if (data.hide_id === 2) {
        customText = ' سيتم إظهار الدورة علي المنصة '
      }
      swal({
        title: 'هل انت متأكد ؟',
        text: customText,
        icon: 'warning',
        buttons: ['لا', 'نعم'],
        dangerMode: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((willDelete) => {
        if (willDelete) {
          this.$http
            .get(
              `${this.$hostUrl}courses/${data.id}/hide`,
              { _method: 'get' }
            )
            .then((response) => {
              console.log(response)
              swal({ title: response.data.message, buttons: 'تم' })
            })
          tr.remove()
          const table = this.$refs.table
          setTimeout(() => {
            table.reload()
          }, 1500)
        } else {
          swal({ title: ' تم الغاء العملية !', buttons: 'تم' })
        }
      })
    },
    doAfterReload (data, table) {
      console.log('data reloaded')
    },
    doCreating (comp, el) {
      console.log('creating')
    },
    doCreated (comp) {
      console.log('created')
    },
    doSearch () {
      this.$refs.table.search(this.quickSearch)
    },
    doExport (type) {
      const parms = this.$refs.table.getServerParams()
      parms.export = type
    },
    formatCode (zipcode) {
      return zipcode.split('-')[0]
    }
  }
}
</script>
